import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api.js";
export const getTeam = async ({ teamId, userId, }) => {
    const team = await api
        .get(`teams/${teamId}/users/${userId}/shareData`)
        .json();
    return team;
};
export const getTeamQueryOptions = (teamId, userId) => {
    return queryOptions({
        queryKey: ["teams", teamId],
        queryFn: () => getTeam({ teamId, userId }),
        staleTime: 1000 * 5,
    });
};
export const useTeam = ({ queryConfig, teamId, userId }) => {
    return useQuery({
        ...getTeamQueryOptions(teamId, userId),
        ...queryConfig,
    });
};
//# sourceMappingURL=getTeam.js.map